import React from 'react';
import {assert} from 'assert-ts';
import {CodeListsGate} from 'services/codelists';
import {isAgentValue} from 'services/utils';
import {FlexBox} from 'components';
import {Preview, useSchemaCodelistIds} from 'schema';
import {entityTypeToSchemaReference} from 'schemas/functions/entityTypeToSchemaReference';
import {useEntitySchema, usePreviewConfiguration} from 'schemas/hooks';
import {AgentWorksTable} from 'widgets/agentWorks';
import type {EntityPreviewContent} from './types';
import {useAgentWorkLink} from '../hooks/useAgentWorkLink';

export const AgentPreviewContent: EntityPreviewContent = ({
  entityType,
  entityValue,
  configuration,
}) => {
  const schema = useEntitySchema(entityType);
  const codeLists = useSchemaCodelistIds(schema);

  const previewConfig = usePreviewConfiguration(
    entityTypeToSchemaReference(entityType),
    configuration,
  );

  const agentValue = isAgentValue(entityValue) ? entityValue : undefined;
  const onRowClick = useAgentWorkLink(agentValue, entityType);

  return (
    <CodeListsGate codeLists={codeLists}>
      <FlexBox>
        <Preview
          schema={assert(schema, 'EntityPreview: schema is not defined')}
          data={entityValue}
          configuration={previewConfig}
        />
        {isAgentValue(entityValue) ? (
          <AgentWorksTable agent={entityValue} onRowClick={onRowClick} />
        ) : null}
      </FlexBox>
    </CodeListsGate>
  );
};
